import React from 'react'
import StagesManager from './StagesManager';
// import SelectQuery from './SelectQuery';
// import Recents from './Recents';
// import SelectName from './SelectName';
// import SelectNameSurvey from './SelectNameSurvey';
// import SelectNameExam from './SelectNameExam';
// import FormBuilderNew from './FormBuilderNew';
import Reports from './Reports';
// import InquirySuccess from './InquirySuccess';
// import { getObject, imageAddress } from '../utils/useful';
// import Header from './header/Header';
// import { nanoid } from 'nanoid';
import HttpServices from '../utils/Http.services';
import Header from './header/Header';
// import DatabaseSettings from '../windows/Applets/database/SettingsSwitcher';


class SingleRecordView extends React.Component {
    state = {
        data: {},
        tempValue: {},
        groupBy: [],
        currentView: "table",
        tabs: [
            { key: "approval", name: "Approval", icon: "/assets/icons/applets/database/approval.svg" },
            { key: "assignee", name: "Assignee", icon: "/assets/icons/applets/database/assignee.svg" },
        ],
        currentTabs: 'approval',
        headerConfig: {
            backAction: () => this.hideModal(),
            // 'title': "View Record",
            // 'subtitle': this.props.page?.subtitle,

        }
    }

    hideModal = () => {
        // console.log('aaaaaaaaaaas')
        this.onClose()
        // setTimeout(() => {
        //     this.setState({ showModal: false })
        // }, 500);
    }
    onClose = () => {
        setTimeout(() => {
            if (this.props.setData) {
                // console.log('aaaaaaaaaaaaaa')
                this.props.setData('editInquiry', false, 'CollectionView', () => {
                    this.setState({ showModal: false, })
                })
            } else {

                this.setState({ showModal: false, }, () => {
                    // this.setState({  })
                })
            }
        }, 10);
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    changeValue = (value) => {
        let tempValue = value
        this.setState({ tempValue }, () => {
        })
    }
    componentDidMount() {
        // console.log('singleRecordViewwwwwwww12', this.props.windowData?.path)
        // console.log('singleRecordViewwwwwwww13', this.props.baseUrl)
        let collectionId = this.props.windowData?.path[this.props.baseUrl.length]

        this.setState({ collectionId }, () => {
            // console.log('singleRecordViewwwwwwww1', collectionId)
            this.init()
        })

    }
    componentDidUpdate(prevProps) {
        // console.log('this.props.windowData.pathllww', this.props.windowData.path)

        // if (JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path)) {
        //     console.log('updatedddssssssss',JSON.stringify(this.props.windowData.path))
        //     console.log('prevProps.windowData.path',JSON.stringify(prevProps.windowData.path))
        //     // let collectionId = this.props.windowData?.path[this.props.baseUrl?.length]
        //     // this.setState({ collectionId }, () => {
        //     //     this.init()
        //     // })
        // }
        // console.log('singleRecordViewwwwwwww', this.props.data)

    }

    init() {
        this.setState({ data: {} }, () => {
            this.fetchData()
        })

    }


    fetchData = () => {
        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeee', this.props.page);
        // let data = this.state.data
        this.setState({ isLoadingData: true })
        let body = JSON.parse(JSON.stringify(this.props.page.filter ?? {}))
        // let page = this.props.page

        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }
        let id = this.props.windowData.path[this.props.windowData.path.length - 1]
        // console.log('this.props.windowData.pathll', this.props.windowData.path)
        body.frame = JSON.parse(JSON.stringify(this.props.page?._id))
        body._id = id
        // console.log('this.props.page', this.props.page)
        // console.log('idsssss', id)
        // console.log('byddd', body)
        HttpServices.request('getRecord', body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            // console.log('fetchErrorobject', fetchError)
            // console.log('test', this.props)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log('fetchResultres', fetchResult)
            // console.log('fetchResulterr', fetchError)
            this.setState({ showTable: false }, () => {
                this.setState({ data: fetchResult.info, showTable: true }, () => {
                    // if (this.state.data.values?.time) {
                    // let value = this.state.data.values.time
                    // console.log('fetchResultres1', String((Number(this.state.data.values.time[0]) * 3600) + (Number(this.state.data.values.time[1]) * 60) + (Number(this.state.data.values.time[2]) * 1)))
                    // data.values.time = String((Number(this.state.data.values.time[0]) * 3600) + (Number(this.state.data.values.time[1]) * 60) + (Number(this.state.data.values.time[2]) * 1))
                    // this.setState({ data })
                    // }
                    // console.log('fetchResultres2', this.state.data)

                    // this.groupBy(0, this.state.records, this.state.groupBy)

                })
            })
        })
    }



    setData = (key, value, reference, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: false,
                    backAction: () => this.hideModal(),
                    // 'title': "View Record",
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    render() {
        // return
        if (this.props.editInquiry) {
            return (
                <div className='h-100 flex-column window-content-radius' style={{ display: (this.props.editInquiry) ? 'flex' : 'none', width: '100%', left: 50, zIndex: 3, backgroundColor: 'rgb(229, 229, 234)' }}>
                    {/* <div style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} setCurrentApplet={this.props.setCurrentApplet} appletType={this.props.type} isPortal={this.props.isPortal} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                    </div> */}

                    <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true}  >
                        <Reports stage={0} stageName={'Reports'}
                            baseUrl={[...this.props.baseUrl]}
                            language={this.props.language}
                            colors={this.props.colors}
                            variables={this.props.variables}
                            participation={this.props.participation}
                            setHeader={this.props.setHeader}
                            collectionId={this.state.collectionId}
                            currentFrame={this.state.currentFrame}
                            backStage={this.backStage}
                            type='quiz'
                            setData={this.props.setData}
                            width={this.props.width}
                            height={this.props.height}
                            currentItem={this.props.currentItem}
                            data={this.state.data}
                            headers={this.props.headers}
                            pages={this.state.pages}
                            changeStage={this.changePageStage}
                            changePage={this.props.changePage}
                            applet={this.props.applet}
                            goToHub={this.props.goToHub}
                            windowData={this.props.windowData}
                            route={this.props.rootUrl}
                            connection={this.props.connection}
                            user={this.props.user}
                            setUser={this.props.setUser}
                            addNotif={this.props.addNotif}
                            history={this.props.history}
                            location={this.props.location}
                            changeWindowLink={this.props.changeWindowLink}
                            page={this.props.page}
                            editInquiry={this.props.editInquiry}
                            defaultCollectionHeader={this.props.defaultCollectionHeader}

                        />

                    </StagesManager>
                </div>

            )
        } else {
            return (
                <div></div>
            )
        }

    }
}

export default SingleRecordView;